import type { UserPanelProps } from './user-panel.interface';

import classNames from 'classnames';
import { memo, useState } from 'react';

export const UserPanel = memo(
  ({
    name,
    email,
    status,
    role,
    className,
    onDelete,
    isDeletable,
    isSelectable,
    isSmall,
    isDisabled,
    onClick,
    isFixed,
  }: UserPanelProps) => {
    const [selected, setSelected] = useState(false);

    const handleClick = () => {
      if (isSelectable) {
        setSelected((prev) => !prev);
      }

      if (onClick) {
        onClick();
      }
    };

    const classList = classNames(
      'entities-item',
      {
        deletable: isDeletable,
        small: isSmall,
        disabled: isDisabled,
        selected,
        hoverable: isSelectable || !!onClick,
        fixed: isFixed,
      },
      className,
    );

    return (
      <div className={classList} onClick={handleClick}>
        <div className="entities-item-content">
          <div className="entities-item__title">
            <div className="user-name">{name}</div>
            <div className="user-email">{email}</div>
            <div className={`user-status status-${status.toLowerCase()}`}>
              {status}
            </div>
            <div className="user-role">{role}</div>
          </div>
          {isDeletable && onDelete && (
            <i
              className="entities-item__delete"
              onClick={(event) => {
                event.stopPropagation();
                onDelete(event);
              }}
            />
          )}
        </div>
      </div>
    );
  },
);

UserPanel.displayName = 'UserPanel';
